import React, { useCallback, useMemo, useState } from "react";
import { Button, Descriptions, Alert, Typography } from "antd";
import { VideoCameraOutlined, LinkOutlined } from "@ant-design/icons";
import { JOIN_MEETING_TOKEN } from "../../../../constant";
import Modal from "../../../../components/generic/Modal";
import httpClient from "../../../../api/httpClient";
import { setLocalStorageItem } from "../../../../constant/localStorage";
import { ROUTES } from "../../../../constant/routes";
import { parseError } from "../../../../utils/shared";
import dayjs from "../../../../utils/dayjs";

const FIELD_MAP = [
  { token: /👤 Created By:\s*(.+)/, label: "Created By" },
  { token: /📝 Title:\s*(.+)/, label: "Title" },
  { token: /📋 Description:\s*(.+)/, label: "Description" },
  { token: /🕐 Start Time:\s*(.+)/, label: "Start Time" },
  { token: /⏱️ Duration:\s*(.+)/, label: "Duration" },
  { token: /🏠 Room Code:\s*(.+)/, label: "Room Code" },
  { token: /🔑 Room Password:\s*(.+)/, label: "Room Password" },
];

const parseMessage = (message = "") => {
  const parsed = {};
  message.split("\n").forEach((line) => {
    FIELD_MAP.forEach(({ token, label }) => {
      const match = line.match(token);
      if (match) {
        let value = match[1].trim();
        if (label === "Start Time") {
          const localTime = dayjs.utc(value).local();
          value = localTime.format("DD MMM YYYY, hh:mm A");
        }
        parsed[label] = value;
      }
    });
  });
  return parsed;
};

const JoinMeeting = ({ message }) => {
  const [open, setOpen] = useState(false);

  const displayText = useMemo(
    () =>
      message
        ?.replace(JOIN_MEETING_TOKEN, "")
        .replace(/🕐 Start Time:\s*(.+)/, (_, utcTime) => {
          const local = dayjs.utc(utcTime).local();
          return `🕐 Start Time: ${local.format("DD MMM YYYY, hh:mm A")}`;
        })
        .trimEnd(),
    [message],
  );

  const parsed = useMemo(() => parseMessage(message), [message]);

  return (
    <>
      <div style={{ whiteSpace: "pre-line", lineHeight: 1.8 }}>
        {displayText}
        {"\n"}

        <Typography.Link
          href={`${ROUTES.MEETING_ROOM}/${parsed["Room Code"]}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary"
        >
          <LinkOutlined /> Click Here To Join Meeting
        </Typography.Link>
        <br />
        <Button
          type="primary"
          icon={<VideoCameraOutlined />}
          size="small"
          style={{ marginTop: 6 }}
          onClick={() => setOpen(true)}
        >
          View Meeting Details
        </Button>
      </div>

      <Modal
        title={
          <>
            <VideoCameraOutlined style={{ marginRight: 8 }} />
            Meeting Details
          </>
        }
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={440}
      >
        <Descriptions
          column={1}
          bordered
          size="small"
          style={{ marginTop: 12 }}
        >
          {FIELD_MAP.map(({ label }) =>
            parsed[label] && parsed[label] != "null" ? (
              <Descriptions.Item key={label} label={label}>
                {parsed[label]}
              </Descriptions.Item>
            ) : (
              <></>
            ),
          )}
        </Descriptions>

        <Alert
          type="success"
          showIcon
          style={{ marginTop: 12 }}
          title="Meeting Ready!"
          description={
            <Button
              type="link"
              icon={<LinkOutlined />}
              href={`${ROUTES.MEETING_ROOM}/${parsed["Room Code"]}`}
              target="_blank"
              className="text-primary"
              style={{ padding: 0 }}
            >
              Click here to join meeting
            </Button>
          }
        />
      </Modal>
    </>
  );
};

export default JoinMeeting;
